import React, { useState, useEffect, useContext, useMemo, useCallback } from "react";
import "./CustomTable.css";
import { utils } from "helper";
import {
  AddButton,
  CityDropdownForTrip,
  CommonDateRange,
  CommonInput,
  CommonModal,
  CrossButton,
} from "components/common";
import { UserContext } from "context";
import { FaRegTrashCan } from "react-icons/fa6";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import {
  getBranchDropdownListData,
  getConsignorDropdownListData,
} from "_services/dropdownServices/dropdownService";
import CustomSelect from "components/CustomSelect";
import StorageService from "utils/StorageServices/StorageServices";
import { RxCross1, RxCross2 } from "react-icons/rx";
import Loading from "pages/Loading";
import { useSelector } from "react-redux";
import moment from 'moment';
import { BsChevronDown } from "react-icons/bs";
import { getCityLocationList } from "_services/accountsServices/cityLocationService";
import toast from "react-hot-toast";
import { getUserFirm } from "_services/accountsServices/firmServices";

const ItemTypes = {
  COLUMN: "column",
};

const DraggableColumn = ({ column, index, moveColumn, sortConfig, onSort }) => {
  const isDragging = false;

  return (
    <th
      onClick={onSort}
      style={{
        opacity: isDragging ? 0.5 : 1,
        whiteSpace: "nowrap",
        borderLeft: isDragging ? "2px solid #1956F6" : "",
      }}
    >
      <div className="_thFlx">
        <div className="_tbsX">
          {column}
          <div>{sortConfig}</div>
        </div>
        <svg
          className="drager"
          fill="#000000"
          version="1.1"
          id="icon"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          width="20px"
          height="20px"
          viewBox="0 0 32 32"
          xmlSpace="preserve"
        >
          <style
            type="text/css"
            dangerouslySetInnerHTML={{ __html: "\n\t.st0{fill:none;}\n" }}
          />
          <title>draggable</title>
          <rect x={10} y={6} width={4} height={4} />
          <rect x={18} y={6} width={4} height={4} />
          <rect x={10} y={14} width={4} height={4} />
          <rect x={18} y={14} width={4} height={4} />
          <rect x={10} y={22} width={4} height={4} />
          <rect x={18} y={22} width={4} height={4} />
          <rect
            id="_Transparent_Rectangle_"
            className="st0"
            width={32}
            height={32}
          />
        </svg>
      </div>
    </th>
  );
};

const CustomTable = ({
  columns,
  data,
  filterableColumns,
  isMasterFilter = false,
  currentPage,
  setCurrentPage = () => { },
  totalPages,
  onPageChange,
  itemsPerPage,
  setColumns,
  statusApiFilter,
  showingStatus,
  isShowingCheckbox,
  checkedBillRaiseLr,
  listCheckboxHandle,
  handleDeleteListCheckbox,
  isShowingDelete,
  showDropdownFilters,
  showDropdownFilterClass,
  isTableHide = false,
  initialListFilters,
  searchFilterOnChange,
  dropdownFilterOnChange,
  listApiCallOnSaveButtonFunction,
  setLrListFilters,
  AllClearResetFunction,
  resetLRTableColumn,
  loading = false,
  filterShow = false,
  isTemplateName = false,
  totalRecords,
  activeStatus,
  isResetAndFilter = false,
  deleteItem = false,
  deleteItemHandler = () => { },
  searchFilterInvoice = false,
  searchSelectedLrForDelete = false,
  invoiceFilterModal,
  setInvoiceFilterModal = () => { },
  filterCount,
  setFilterCount = () => { },
  searchSelectedLR,
  setSearchSelectedLR = () => { },
  hidePartyFilter,
  format,
  setFormats = () => { },
}) => {
  const { invoiceBillRaiseData, setInvoiceBillRaiseData, cities, masterData, invoiceFilters, setInvoiceFilters } =
    useContext(UserContext);
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: "ascending",
  });
  const [allColumns, setAllColumns] = useState([]); // Extracting 'accessor' from columns
  const [allfilterableColumns, setAllFilterableColumns] = useState([]); // Extracting 'accessor' from columns
  const [visibleColumns, setVisibleColumns] = useState([]); // Extracting 'accessor' from columns
  const [filter, setFilter] = useState({});
  const [viewsDropdownOpen, setViewsDropdownOpen] = useState(false);
  const [filtersDropdownOpen, setFiltersDropdownOpen] = useState(false);
  const [activeFilters, setActiveFilters] = useState(
    columns?.map((col) => col?.accessor)
  ); // Extracting 'accessor' from columns
  const [filterSearch, setFilterSearch] = useState("");
  const [filterSearchInput, setFilterSearchInput] = useState({});
  const [placeholderIndex, setPlaceholderIndex] = useState(null);
  const getSearchValue = useSelector((state) => state.lrSearch);
  // list filter states start

  const [dropdownConsignorList, setDropdownConsignorList] = useState([]);
  const [dropdownBranchList, setDropdownBranchList] = useState([]);
  const [filterlabel, setfilterlabel] = useState({
    branch_id: "",
    consignor_id: "",
    start_date: "",
    end_date: "",
    from_location: "",
    to_location: "",
    pod_status: "",
    eway_bill_status: "",
  });
  const [count, setCount] = useState(0);
  // list filter states end

  useEffect(() => {
    setAllColumns(columns);
    setVisibleColumns(
      columns?.filter((col) => col?.view == 1)?.map((col) => col?.accessor)
    );
    setAllFilterableColumns(filterableColumns);
  }, [columns]);

  const sortedData = React.useMemo(() => {
    if (sortConfig.key) {
      const sorted = [...data].sort((a, b) => {
        const aValue =
          a[sortConfig.key] != null
            ? utils.stripHtmlTags(a[sortConfig.key].toString())
            : "";
        const bValue =
          b[sortConfig.key] != null
            ? utils.stripHtmlTags(b[sortConfig.key].toString())
            : "";

        if (aValue < bValue) {
          return sortConfig.direction === "ascending" ? -1 : 1;
        }
        if (aValue > bValue) {
          return sortConfig.direction === "ascending" ? 1 : -1;
        }
        return 0;
      });
      return sorted;
    }
    return data;
  }, [data, sortConfig]);

  const filteredData = React.useMemo(() => {
    return sortedData
      .filter((item) =>
        Object.keys(filter).every((key) => {
          const itemValue =
            item[key] != null ? utils.stripHtmlTags(item[key].toString()) : "";
          return (
            !filter[key] ||
            filter[key].length === 0 ||
            filter[key].includes(itemValue)
          );
        })
      )
      .filter((item) => {
        return visibleColumns?.some((column) => {
          const itemValue =
            item[column] != null
              ? utils.stripHtmlTags(item[column]?.toString())
              : "";
          return itemValue
            .toString()
            .toLowerCase()
            .includes(filterSearch.toLowerCase());
        });
      });
  }, [sortedData, filter, filterSearch, visibleColumns]);

  const requestSort = (key) => {
    let direction = "ascending";
    if (sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending";
    }
    setSortConfig({ key, direction });
  };

  const toggleViewsDropdown = () => {
    setViewsDropdownOpen(!viewsDropdownOpen);
  };

  const toggleActiveFilter = (column) => {
    setActiveFilters((prevFilters) =>
      prevFilters.includes(column)
        ? prevFilters.filter((filter) => filter !== column)
        : [column]
    );
  };

  const moveColumn = (dragIndex, hoverIndex) => {
    const draggedColumn = visibleColumns[dragIndex];
    const newVisibleColumns = [...visibleColumns];
    const newAllColumns = [...allColumns];

    // Update visibleColumns
    newVisibleColumns.splice(dragIndex, 1);
    newVisibleColumns.splice(hoverIndex, 0, draggedColumn);

    // Find the corresponding column in allColumns
    const draggedAllColumn = allColumns.find(
      (col) => col.accessor === draggedColumn
    );
    const draggedAllIndex = allColumns.indexOf(draggedAllColumn);

    // Remove the dragged column from its original position
    newAllColumns.splice(draggedAllIndex, 1);

    // Insert the dragged column at its new position
    newAllColumns.splice(
      draggedAllIndex < hoverIndex ? hoverIndex : hoverIndex,
      0,
      draggedAllColumn
    );

    // Set the updated columns
    setVisibleColumns(newVisibleColumns);
    setAllColumns(newAllColumns);
    setPlaceholderIndex(null);
  };

  const updateColumnsData = () => {
    setColumns(allColumns);
    setViewsDropdownOpen(false);
  };

  const handleDragProps = {
    isOpen: viewsDropdownOpen,
    closeModal: (e) => setViewsDropdownOpen(false),
    onSubmit: (e) => updateColumnsData(),
    modalMainClass: "_dashCommon_Modal _lgModal blurModal",
    modalTitle: "Customize View",
    submitTitle: "Save",
    cancleTitle: "Cancel",
    footerPart: true,
    resetButtonTitle: "Reset",
    resetButtonClick: (e) => resetLRTableColumn(),
  };

  const toggleOffcanvas = () => {
    if (!!filterShow) {
      setFiltersDropdownOpen(!filtersDropdownOpen);
    }
  };

  const renderPagination = () => {
    const paginationRange = 2; // Number of pages to show around the current page
    let startPage = Math.max(1, currentPage - paginationRange);
    let endPage = Math.min(totalPages, currentPage + paginationRange);

    if (currentPage <= paginationRange) {
      endPage = Math.min(totalPages, paginationRange * 2 + 1);
    }

    if (currentPage > totalPages - paginationRange) {
      startPage = Math.max(1, totalPages - paginationRange * 2);
    }

    const pages = [];
    for (let page = startPage; page <= endPage; page++) {
      pages.push(
        <button
          key={page}
          className={
            currentPage === page ? "_paginateBtn active" : "_paginateBtn"
          }
          // style={{ background: currentPage === page ? 'blue' : '' }}
          onClick={() => onPageChange(page)}
        >
          {page}
        </button>
      );
    }

    return pages;
  };

  // handle checkbox

  const onDragEnd = (result) => {
    if (!result?.destination) return;
    const tempData = [...allColumns];
    const [selectedColumn] = tempData.splice(result.source.index, 1);
    tempData.splice(result.destination.index, 0, selectedColumn);
    setAllColumns(tempData);
  };

  const getColumnId = (column) => {
    if (column?.accessor && column?.accessor != "") return column?.accessor;
    return column.Header.toLowerCase().replaceAll(" ", "_");
  };

  const handleCheckboxChange = (item) => {
    const isColumnVisible = visibleColumns.includes(item.accessor);
    const isVisible = !isColumnVisible;

    const updatedColumns = allColumns.map((col) => {
      if (col.accessor == item.accessor) {
        return { ...col, view: isVisible ? 1 : 0 };
      }
      return col;
    });

    setAllColumns(updatedColumns);

    const updatedVisibleColumns = visibleColumns.map((col) => {
      if (col.accessor == item.accessor) {
        return { ...col, view: isVisible ? 1 : 0 };
      }
      return col;
    });
    updatedColumns.sort((a, b) => {
      if (a.view == 1 && b.view == 0) return -1; // a should come before b
      if (a.view == 0 && b.view == 1) return 1; // b should come before a
      return 0; // maintain current order
    });

    setAllColumns(updatedColumns);
    setVisibleColumns(updatedVisibleColumns);
    setVisibleColumns((prevColumns) =>
      prevColumns.includes(item?.accessor)
        ? prevColumns.filter((col) => col !== item?.accessor)
        : [...prevColumns, item?.accessor]
    );
    // toggleActiveFilter(item);
  };

  const getDropdownDataConsignorList = async () => {
    try {
      let object = {
        company_id: StorageService.getCompanyId(),
        firm_id: StorageService.getFirmId(),
        limit: 100,
        offset: 1,
        search: "",
      };
      const res = await getConsignorDropdownListData(object);
      if (res?.responseCode == 200) {
        setDropdownConsignorList([
          { name: "All", _id: "" },
          ...res?.data?.consignor_list,
        ]);
      }
    } catch (error) {
      throw error;
    }
  };

  const getDropdownDataBranchList = async () => {
    try {
      let object = {
        company_id: StorageService.getCompanyId(),
        firm_id: StorageService.getFirmId(),
        limit: 100,
        offset: 1,
        search: "",
      };
      const res = await getBranchDropdownListData(object);
      if (res?.responseCode == 200) {
        setDropdownBranchList([
          { branch: "All", _id: "" },
          ...res?.data?.branch_list,
        ]);
      }
    } catch (error) {
      // throw error;
    }
  };

  useEffect(() => {
    if (filtersDropdownOpen) {
      getDropdownDataConsignorList();
      getDropdownDataBranchList();
    }
  }, [filtersDropdownOpen]);

  const saveButtonApicall = () => {
    // setfilterlabel(initialListFilters);
    listApiCallOnSaveButtonFunction(filterlabel);
    setFiltersDropdownOpen(false);
  };

  const getFilterLabelCount = (filterlabel) => {
    let count = 0;

    Object.values(filterlabel).forEach((value) => {
      if (typeof value === "object" && value !== null) {
        if ("value" in value) {
          if (typeof value.value === "string" && value.value.trim() !== "") {
            count += 1;
          } else if (typeof value.value === "number" && value.value !== 0) {
            count += 1;
          }
        }
      } else if (typeof value === "string" && value.trim() !== "") {
        count += 1;
      } else if (typeof value === "number" && value !== 0) {
        count += 1;
      }
    });
    return count;
  };

  useEffect(() => {
    let countValue = getFilterLabelCount({
      branch_id: initialListFilters?.branch_id?.value
        ? initialListFilters?.branch_id
        : "",
      consignor_id: initialListFilters?.consignor_id?.value
        ? initialListFilters?.consignor_id
        : "",
      start_date: initialListFilters?.start_date != "" ? 1 : "",
      end_date: initialListFilters?.end_date != "" ? 1 : "",
      from_location: initialListFilters?.from_location?.value
        ? initialListFilters?.from_location
        : "",
      to_location: initialListFilters?.to_location?.value
        ? initialListFilters?.to_location
        : "",
      pod_status: initialListFilters?.pod_status
        ? initialListFilters?.pod_status
        : "",
      eway_bill_status: initialListFilters?.eway_bill_status
        ? initialListFilters?.eway_bill_status
        : "",
    });
    setCount(countValue);
    setfilterlabel(initialListFilters);
  }, [initialListFilters]);

  // Calculate the start and end row for the current page
  const startRow = (currentPage - 1) * itemsPerPage + 1;
  const endRow = Math.min(currentPage * itemsPerPage, totalRecords);

  const fetchFromCity = useCallback(async (search, page, limit) => {
    try {
      const response = await getCityLocationList({
        countryCode: "IN",
        stateCode: "",
        offset: page,
        limit,
        search,
      });

      if (response?.responseCode === 200) {
        const cities = response.data.all_cities.map(city => ({
          ...city,
          _id: city.name,
          value: city.name,
          label: city.name, // `${city.name}, ${city.stateName}`
        }));

        const result = {
          items: cities, // [{ label: 'All Location', value: '' }, ...cities],
          total: response.data.total_record,
        };
        return result;
      }
      toast.error(response?.responseMessage);
      return { items: [], total: 0 };
    } catch (error) {
      return { items: [], total: 0 };
    }
  }, []);

  return (
    <>
      <div
        className={
          isTableHide
            ? ""
            : showDropdownFilterClass
              ? "_mainData_tableOtr _mainData_withUp_filts"
              : "_mainData_tableOtr"
        }
      >
        <div className="_allFilts ">
          <div className="filterOtrs">
            {statusApiFilter}
            {showingStatus}

            <div className="_allFilts_fxs">
              {!isTableHide ? (
                <>
                  {!isResetAndFilter ? (
                    <>
                      <div className="_inpW_search _lrl_inpSrch">
                        <svg
                          className="srcIcon"
                          xmlns="http://www.w3.org/2000/svg"
                          width="18"
                          height="18"
                          viewBox="0 0 18 18"
                          fill="none"
                        >
                          <path
                            opacity="0.2"
                            d="M17.347 16.3507L12.7293 11.733C13.8389 10.4008 14.3923 8.69214 14.2742 6.96238C14.1562 5.23263 13.3757 3.61498 12.0954 2.44596C10.815 1.27695 9.13319 0.64656 7.39985 0.685944C5.66652 0.725329 4.0151 1.43145 2.78913 2.65742C1.56317 3.88339 0.857043 5.53481 0.817658 7.26814C0.778274 9.00147 1.40866 10.6833 2.57768 11.9636C3.7467 13.244 5.36434 14.0244 7.0941 14.1425C8.82385 14.2606 10.5325 13.7072 11.8647 12.5976L16.4824 17.2153L17.347 16.3507ZM2.06069 7.43204C2.06069 6.34363 2.38344 5.27967 2.98812 4.3747C3.5928 3.46972 4.45227 2.76438 5.45782 2.34787C6.46337 1.93135 7.56985 1.82238 8.63734 2.03471C9.70483 2.24705 10.6854 2.77117 11.455 3.54078C12.2246 4.3104 12.7487 5.29095 12.9611 6.35844C13.1734 7.42593 13.0644 8.53241 12.6479 9.53797C12.2314 10.5435 11.5261 11.403 10.6211 12.0077C9.71611 12.6124 8.65215 12.9351 7.56375 12.9351C6.10474 12.9335 4.70596 12.3532 3.67428 11.3215C2.64261 10.2898 2.0623 8.89104 2.06069 7.43204Z"
                            fill="black"
                          />
                        </svg>
                        <input
                          type="text"
                          placeholder="Search"
                          className="simpleFilter_input"
                          name="search"
                          value={getSearchValue?.search}
                          onChange={(e) =>
                            searchFilterOnChange("search", e.target.value)
                          }

                          style={{ paddingRight: getSearchValue?.search ? "35px" : "6px" }}
                        />
                        {getSearchValue?.search ? (
                          <span
                            className="clear-icon"
                            onClick={(e) => searchFilterOnChange("")}
                          >
                            <RxCross2 size={20} color="black" />
                          </span>
                        ) : (
                          <></>
                        )}
                      </div>
                      {count > 0 && (
                        <div className="_appliedFilts_bx">

                          <div className="d-flex align-items-center gap-1 _avPointer" onClick={toggleOffcanvas}>
                            <span className="d-flex">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="11"
                                height="11"
                                viewBox="0 0 11 11"
                                fill="none"
                              >
                                <path
                                  d="M4.90652 10.7371C4.71844 10.7371 4.56079 10.6735 4.43354 10.5463C4.3063 10.419 4.24267 10.2614 4.24267 10.0733V6.09015L0.276151 1.02828C0.121261 0.840193 0.0991417 0.641038 0.209766 0.430809C0.320417 0.22058 0.491904 0.115479 0.724252 0.115479H10.4165C10.6489 0.115479 10.8204 0.22058 10.931 0.430809C11.0416 0.641038 11.0195 0.840193 10.8646 1.02828L6.89808 6.09015V10.0733C6.89808 10.2614 6.83449 10.419 6.70724 10.5463C6.57999 10.6735 6.42234 10.7371 6.23423 10.7371H4.90652Z"
                                  fill="#0067DE"
                                />
                              </svg>
                            </span>
                            <span
                              className="_apl_text _avPointer"
                              // onClick={toggleOffcanvas}
                            >
                              {count} Filter{count > 1 ? "s" : ""}
                            </span>
                          </div>

                          <button
                            className="_resetCrox_btn"
                            onClick={(e) => {
                              if (!!filterShow) {
                                setfilterlabel((s) => ({
                                  ...s,
                                  branch_id: { label: "", value: "" },
                                  consignor_id: { label: "", value: "" },
                                  start_date: "",
                                  end_date: "",
                                  from_location: { label: "", value: "" },
                                  to_location: { label: "", value: "" },
                                  pod_status: { label: "", value: "" },
                                  eway_bill_status: { label: "", value: "" },
                                }));
                                AllClearResetFunction();
                              }
                            }}
                          >
                            <RxCross2 />
                          </button>


                          {/* <button
                            className="_resetApl_btn"
                            onClick={(e) => {
                              if (!!filterShow) {
                                setfilterlabel((s) => ({
                                  ...s,
                                  branch_id: { label: "", value: "" },
                                  consignor_id: { label: "", value: "" },
                                  start_date: "",
                                  end_date: "",
                                  from_location: { label: "", value: "" },
                                  to_location: { label: "", value: "" },
                                  pod_status: { label: "", value: "" },
                                  eway_bill_status: { label: "", value: "" },
                                }));
                                AllClearResetFunction();
                              }
                            }}
                          >
                            {" "}
                            Reset{" "}
                          </button> */}
                        </div>
                      )}
                    </>
                  ) : (
                    <></>
                  )}

                  {!count && (
                    <div className="column-toggle-dropdown">
                      <button
                        onClick={toggleOffcanvas}
                        className="column-toggle-dropdown-toggle"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="11"
                          height="11"
                          viewBox="0 0 11 11"
                          fill="none"
                        >
                          <path
                            d="M4.90652 10.7371C4.71844 10.7371 4.56079 10.6735 4.43354 10.5463C4.3063 10.419 4.24267 10.2614 4.24267 10.0733V6.09015L0.276151 1.02828C0.121261 0.840193 0.0991417 0.641038 0.209766 0.430809C0.320417 0.22058 0.491904 0.115479 0.724252 0.115479H10.4165C10.6489 0.115479 10.8204 0.22058 10.931 0.430809C11.0416 0.641038 11.0195 0.840193 10.8646 1.02828L6.89808 6.09015V10.0733C6.89808 10.2614 6.83449 10.419 6.70724 10.5463C6.57999 10.6735 6.42234 10.7371 6.23423 10.7371H4.90652Z"
                            fill="#142B4B"
                          />
                        </svg>
                        Filter
                      </button>
                    </div>
                  )}

                  {/* ------------------------ Only Invoice Search and Filters ---------------------- */}
                  {
                    searchFilterInvoice && (
                      <>
                        <div className="_inpW_search _lrl_inpSrch">
                          <svg
                            className="srcIcon"
                            xmlns="http://www.w3.org/2000/svg"
                            width="18"
                            height="18"
                            viewBox="0 0 18 18"
                            fill="none"
                          >
                            <path
                              opacity="0.2"
                              d="M17.347 16.3507L12.7293 11.733C13.8389 10.4008 14.3923 8.69214 14.2742 6.96238C14.1562 5.23263 13.3757 3.61498 12.0954 2.44596C10.815 1.27695 9.13319 0.64656 7.39985 0.685944C5.66652 0.725329 4.0151 1.43145 2.78913 2.65742C1.56317 3.88339 0.857043 5.53481 0.817658 7.26814C0.778274 9.00147 1.40866 10.6833 2.57768 11.9636C3.7467 13.244 5.36434 14.0244 7.0941 14.1425C8.82385 14.2606 10.5325 13.7072 11.8647 12.5976L16.4824 17.2153L17.347 16.3507ZM2.06069 7.43204C2.06069 6.34363 2.38344 5.27967 2.98812 4.3747C3.5928 3.46972 4.45227 2.76438 5.45782 2.34787C6.46337 1.93135 7.56985 1.82238 8.63734 2.03471C9.70483 2.24705 10.6854 2.77117 11.455 3.54078C12.2246 4.3104 12.7487 5.29095 12.9611 6.35844C13.1734 7.42593 13.0644 8.53241 12.6479 9.53797C12.2314 10.5435 11.5261 11.403 10.6211 12.0077C9.71611 12.6124 8.65215 12.9351 7.56375 12.9351C6.10474 12.9335 4.70596 12.3532 3.67428 11.3215C2.64261 10.2898 2.0623 8.89104 2.06069 7.43204Z"
                              fill="black"
                            />
                          </svg>
                          <input
                            type="text"
                            placeholder="Search"
                            className="simpleFilter_input"
                            name="search"
                            value={invoiceFilters?.search}
                            onChange={(e) => setInvoiceFilters({ ...invoiceFilters, search: e.target.value })}
                          />
                          {invoiceFilters?.search ? (
                            <span
                              className="clear-icon"
                              onClick={(e) => setInvoiceFilters({ ...invoiceFilters, search: "" })}
                            >
                              <RxCross2 size={20} color="black" />
                            </span>
                          ) : (
                            <></>
                          )}
                        </div>
                        {filterCount > 0 && (
                          <div className="_appliedFilts_bx">
                            <span>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="11"
                                height="11"
                                viewBox="0 0 11 11"
                                fill="none"
                              >
                                <path
                                  d="M4.90652 10.7371C4.71844 10.7371 4.56079 10.6735 4.43354 10.5463C4.3063 10.419 4.24267 10.2614 4.24267 10.0733V6.09015L0.276151 1.02828C0.121261 0.840193 0.0991417 0.641038 0.209766 0.430809C0.320417 0.22058 0.491904 0.115479 0.724252 0.115479H10.4165C10.6489 0.115479 10.8204 0.22058 10.931 0.430809C11.0416 0.641038 11.0195 0.840193 10.8646 1.02828L6.89808 6.09015V10.0733C6.89808 10.2614 6.83449 10.419 6.70724 10.5463C6.57999 10.6735 6.42234 10.7371 6.23423 10.7371H4.90652Z"
                                  fill="#0067DE"
                                />
                              </svg>
                            </span>
                            <span
                              className="_apl_text _avPointer"
                              onClick={(e) => setInvoiceFilterModal(true)}
                            >
                              {" "}
                              {filterCount} Filter Applied{" "}
                            </span>
                            <button
                              className="_resetApl_btn"
                              onClick={(e) => {
                                setInvoiceFilters({
                                  from_location: {},
                                  to_location: {},
                                  pod_status: {},
                                  vehicle_id: {},
                                  vehicle_ownership: {},
                                  lr_date_range: {
                                    start_date: "",
                                    end_date: ""
                                  },
                                  dispatch_date_range: {
                                    start_date: "",
                                    end_date: ""
                                  },
                                  indent_date_range: {
                                    start_date: "",
                                    end_date: ""
                                  },
                                  pod_date_range: {
                                    start_date: "",
                                    end_date: ""
                                  },
                                  consignor_id: {},
                                  template_id: {},
                                  company_id: "",
                                  limit: 25,
                                  offset: 1,
                                  search: "",
                                  sort_field: "lr_number",
                                  sort_order: "asc"
                                });
                                setFilterCount(0);
                              }}
                            >
                              {" "}
                              Reset{" "}
                            </button>
                          </div>
                        )}

                        {!filterCount && (
                          <div className="column-toggle-dropdown">
                            <button
                              onClick={(e) => setInvoiceFilterModal(true)}
                              className="column-toggle-dropdown-toggle"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="11"
                                height="11"
                                viewBox="0 0 11 11"
                                fill="none"
                              >
                                <path
                                  d="M4.90652 10.7371C4.71844 10.7371 4.56079 10.6735 4.43354 10.5463C4.3063 10.419 4.24267 10.2614 4.24267 10.0733V6.09015L0.276151 1.02828C0.121261 0.840193 0.0991417 0.641038 0.209766 0.430809C0.320417 0.22058 0.491904 0.115479 0.724252 0.115479H10.4165C10.6489 0.115479 10.8204 0.22058 10.931 0.430809C11.0416 0.641038 11.0195 0.840193 10.8646 1.02828L6.89808 6.09015V10.0733C6.89808 10.2614 6.83449 10.419 6.70724 10.5463C6.57999 10.6735 6.42234 10.7371 6.23423 10.7371H4.90652Z"
                                  fill="#142B4B"
                                />
                              </svg>
                              Filter
                            </button>
                          </div>
                        )}
                      </>
                    )
                  }
                  {/* ------------------------ Only Invoice Search and Filters ---------------------- */}

                  {/* ------------------------Only Invoice Search For Selected Lr For Delete -------------------------- */}
                  {
                    searchSelectedLrForDelete && (
                      <>
                        <div className="_inpW_search _lrl_inpSrch">
                          <svg
                            className="srcIcon"
                            xmlns="http://www.w3.org/2000/svg"
                            width="18"
                            height="18"
                            viewBox="0 0 18 18"
                            fill="none"
                          >
                            <path
                              opacity="0.2"
                              d="M17.347 16.3507L12.7293 11.733C13.8389 10.4008 14.3923 8.69214 14.2742 6.96238C14.1562 5.23263 13.3757 3.61498 12.0954 2.44596C10.815 1.27695 9.13319 0.64656 7.39985 0.685944C5.66652 0.725329 4.0151 1.43145 2.78913 2.65742C1.56317 3.88339 0.857043 5.53481 0.817658 7.26814C0.778274 9.00147 1.40866 10.6833 2.57768 11.9636C3.7467 13.244 5.36434 14.0244 7.0941 14.1425C8.82385 14.2606 10.5325 13.7072 11.8647 12.5976L16.4824 17.2153L17.347 16.3507ZM2.06069 7.43204C2.06069 6.34363 2.38344 5.27967 2.98812 4.3747C3.5928 3.46972 4.45227 2.76438 5.45782 2.34787C6.46337 1.93135 7.56985 1.82238 8.63734 2.03471C9.70483 2.24705 10.6854 2.77117 11.455 3.54078C12.2246 4.3104 12.7487 5.29095 12.9611 6.35844C13.1734 7.42593 13.0644 8.53241 12.6479 9.53797C12.2314 10.5435 11.5261 11.403 10.6211 12.0077C9.71611 12.6124 8.65215 12.9351 7.56375 12.9351C6.10474 12.9335 4.70596 12.3532 3.67428 11.3215C2.64261 10.2898 2.0623 8.89104 2.06069 7.43204Z"
                              fill="black"
                            />
                          </svg>
                          <input
                            type="text"
                            placeholder="Search"
                            className="simpleFilter_input"
                            name="search"
                            value={searchSelectedLR}
                            onChange={(e) => { setSearchSelectedLR(e.target.value); setCurrentPage(1) }}
                          />
                          {searchSelectedLR != '' ? (
                            <span
                              className="clear-icon"
                              onClick={(e) => { setSearchSelectedLR(''); setCurrentPage(1) }}
                            >
                              <RxCross2 size={20} color="black" />
                            </span>
                          ) : (
                            <></>
                          )}
                        </div>
                      </>
                    )
                  }
                  {/* ------------------------Only Invoice Search For Selected Lr For Delete -------------------------- */}

                  <div className="column-toggle-dropdown">
                    <button
                      onClick={toggleViewsDropdown}
                      className="column-toggle-dropdown-toggle"
                    >
                      <svg
                        width="15"
                        height="15"
                        viewBox="0 0 15 15"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M5.5 3C4.67157 3 4 3.67157 4 4.5C4 5.32843 4.67157 6 5.5 6C6.32843 6 7 5.32843 7 4.5C7 3.67157 6.32843 3 5.5 3ZM3 5C3.01671 5 3.03323 4.99918 3.04952 4.99758C3.28022 6.1399 4.28967 7 5.5 7C6.71033 7 7.71978 6.1399 7.95048 4.99758C7.96677 4.99918 7.98329 5 8 5H13.5C13.7761 5 14 4.77614 14 4.5C14 4.22386 13.7761 4 13.5 4H8C7.98329 4 7.96677 4.00082 7.95048 4.00242C7.71978 2.86009 6.71033 2 5.5 2C4.28967 2 3.28022 2.86009 3.04952 4.00242C3.03323 4.00082 3.01671 4 3 4H1.5C1.22386 4 1 4.22386 1 4.5C1 4.77614 1.22386 5 1.5 5H3ZM11.9505 10.9976C11.7198 12.1399 10.7103 13 9.5 13C8.28967 13 7.28022 12.1399 7.04952 10.9976C7.03323 10.9992 7.01671 11 7 11H1.5C1.22386 11 1 10.7761 1 10.5C1 10.2239 1.22386 10 1.5 10H7C7.01671 10 7.03323 10.0008 7.04952 10.0024C7.28022 8.8601 8.28967 8 9.5 8C10.7103 8 11.7198 8.8601 11.9505 10.0024C11.9668 10.0008 11.9833 10 12 10H13.5C13.7761 10 14 10.2239 14 10.5C14 10.7761 13.7761 11 13.5 11H12C11.9833 11 11.9668 10.9992 11.9505 10.9976ZM8 10.5C8 9.67157 8.67157 9 9.5 9C10.3284 9 11 9.67157 11 10.5C11 11.3284 10.3284 12 9.5 12C8.67157 12 8 11.3284 8 10.5Z"
                          fill="currentColor"
                          fillRule="evenodd"
                          clipRule="evenodd"
                        ></path>
                      </svg>
                      Views
                    </button>
                  </div>
                </>
              ) : (
                <div className="filterOtrs">
                  <div className="_allFilts_fxs"></div>
                </div>
              )}
            </div>
          </div>
        </div>

        {showDropdownFilters && <div>{showDropdownFilters}</div>}
        {!isTableHide &&
          (loading ? (
            <div colSpan="100%" className="loaderBg" style={{ textAlign: "center" }}>
              <Loading />
            </div>
          ) : (
            <div className="datagrid-table">
              <table className="simple-table">
                <thead>
                  <tr>
                    <th></th>
                    <th>
                      <div className="srNo">Sr. No</div>
                    </th>
                    {visibleColumns?.map((column, index) => (
                      <DraggableColumn
                        key={column}
                        column={
                          columns?.find((col) => col?.accessor === column)?.Header
                        }
                        index={index}
                        moveColumn={moveColumn}
                        onSort={() => requestSort(column)}
                        sortConfig={
                          sortConfig.key === column ? (
                            sortConfig.direction === "ascending" ? (
                              <span>
                                <svg
                                  width="15"
                                  height="15"
                                  viewBox="0 0 15 15"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                  className="ml-2 h-4 w-4"
                                >
                                  <path
                                    d="M7.14645 2.14645C7.34171 1.95118 7.65829 1.95118 7.85355 2.14645L11.8536 6.14645C12.0488 6.34171 12.0488 6.65829 11.8536 6.85355C11.6583 7.04882 11.3417 7.04882 11.1464 6.85355L8 3.70711L8 12.5C8 12.7761 7.77614 13 7.5 13C7.22386 13 7 12.7761 7 12.5L7 3.70711L3.85355 6.85355C3.65829 7.04882 3.34171 7.04882 3.14645 6.85355C2.95118 6.65829 2.95118 6.34171 3.14645 6.14645L7.14645 2.14645Z"
                                    fill="currentColor"
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                  ></path>
                                </svg>
                              </span>
                            ) : (
                              <span>
                                <svg
                                  width="15"
                                  height="15"
                                  viewBox="0 0 15 15"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                  className="ml-2 h-4 w-4"
                                >
                                  <path
                                    d="M7.5 2C7.77614 2 8 2.22386 8 2.5L8 11.2929L11.1464 8.14645C11.3417 7.95118 11.6583 7.95118 11.8536 8.14645C12.0488 8.34171 12.0488 8.65829 11.8536 8.85355L7.85355 12.8536C7.75979 12.9473 7.63261 13 7.5 13C7.36739 13 7.24021 12.9473 7.14645 12.8536L3.14645 8.85355C2.95118 8.65829 2.95118 8.34171 3.14645 8.14645C3.34171 7.95118 3.65829 7.95118 3.85355 8.14645L7 11.2929L7 2.5C7 2.22386 7.22386 2 7.5 2Z"
                                    fill="currentColor"
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                  ></path>
                                </svg>
                              </span>
                            )
                          ) : (
                            <span>
                              <svg
                                width="15"
                                height="15"
                                viewBox="0 0 15 15"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                className="ml-2 h-4 w-4"
                              >
                                <path
                                  d="M4.93179 5.43179C4.75605 5.60753 4.75605 5.89245 4.93179 6.06819C5.10753 6.24392 5.39245 6.24392 5.56819 6.06819L7.49999 4.13638L9.43179 6.06819C9.60753 6.24392 9.89245 6.24392 10.0682 6.06819C10.2439 5.89245 10.2439 5.60753 10.0682 5.43179L7.81819 3.18179C7.73379 3.0974 7.61933 3.04999 7.49999 3.04999C7.38064 3.04999 7.26618 3.0974 7.18179 3.18179L4.93179 5.43179ZM10.0682 9.56819C10.2439 9.39245 10.2439 9.10753 10.0682 8.93179C9.89245 8.75606 9.60753 8.75606 9.43179 8.93179L7.49999 10.8636L5.56819 8.93179C5.39245 8.75606 5.10753 8.75606 4.93179 8.93179C4.75605 9.10753 4.75605 9.39245 4.93179 9.56819L7.18179 11.8182C7.35753 11.9939 7.64245 11.9939 7.81819 11.8182L10.0682 9.56819Z"
                                  fill="currentColor"
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                ></path>
                              </svg>
                            </span>
                          )
                        }
                      />
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {(filteredData?.length === 0 || filteredData?.length < 0) && (
                    <tr>
                      {" "}
                      <td colSpan={visibleColumns?.length}>
                        {" "}
                        No Data Found{" "}
                      </td>{" "}
                    </tr>
                  )}
                  {filteredData.map((row, index) => {
                    const serialNumber =
                      (currentPage - 1) * itemsPerPage + index + 1;
                    return (
                      <>
                        <style>
                          {`
                          .__lrdActions_nxs {
                              display: flex;
                              align-items: center;
                              gap: 10px;
                              }

                              .__prtInx {
                              display: flex;
                              align-items: center;
                              gap: 8px;
                              }

                              .__prtLr_bxs .btn.anime-btn {
                              background-color: #f0f0f0;
                              border: 1px solid #d4d4d4;
                              min-height: 28px;
                              color: var(--black-color);
                              text-align: center;
                              font-size: 13px;
                              font-weight: 400;
                              padding: 2px 10px;
                              border-radius: 4px;
                              transition: all 0.23s;
                              }

                              .__prtLr_bxs ul.dropdown-menu {
                              padding: 0;
                              font-size: 13px;
                              }

                              .__prtLr_bxs ul.dropdown-menu li {
                              padding: 6px 14px;
                              border-bottom: 1px solid #e5e5e5;
                              cursor: pointer;
                              }

                              .__prtLr_bxs ul.dropdown-menu li:last-child {
                              border-bottom: none;
                              }

                              .__prtLr_bxs ul.dropdown-menu li:hover {
                              background: #0056f014;
                              }

                              /*.__prtLr_bxs .dropdown-toggle::after {
                              display: none;
                              }*/
                              `}
                        </style>
                        <tr key={index}>
                          <td>
                            {deleteItem ?
                              <div className="__lrdActions_nxs">
                                <span
                                  className="_del_lrM_btn _avPointer"
                                  onClick={() => deleteItemHandler(row?.originalData)}
                                >
                                  <FaRegTrashCan className="del_lrCion" />
                                  <span>Delete</span>
                                </span>

                                <div className="__prtLr_bxs" >
                                  <button type="button" className="btn anime-btn " data-bs-toggle="dropdown" aria-expanded="false">
                                    <div className="__prtInx">Print <BsChevronDown /></div>
                                  </button>

                                  <ul className='dropdown-menu '>
                                    <li className='' onClick={() => setFormats({ ...format, lr_with_pod: 0, lr_id: row?.originalData?._id, originalData: row?.originalData })}>LR Print</li>
                                    <li className='' onClick={() => setFormats({ ...format, lr_with_pod: 1, lr_id: row?.originalData?._id, originalData: row?.originalData })}>LR + POD Print</li>
                                  </ul>

                                </div>
                              </div>
                              : <></>
                            }
                            {isShowingCheckbox ? (
                              <>
                                <input
                                  type="checkbox"
                                  id={`checkbox-${row?._id}`}
                                  checked={checkedBillRaiseLr?.includes(row?._id)}
                                  onChange={(e) => listCheckboxHandle(row._id)}
                                />
                                <label htmlFor={`checkbox-${row._id}`}>
                                  {" "}
                                  <span className="_invisibleSpan">.</span>{" "}
                                </label>
                              </>
                            ) : (
                              <></>
                            )}
                            {isShowingDelete ? (
                              invoiceBillRaiseData?.select_lr_ids?.length ===
                                1 ? (
                                <></>
                              ) : (
                                <span
                                  className="_del_lrM_btn _avPointer"
                                  onClick={(e) =>
                                    handleDeleteListCheckbox(row._id)
                                  }
                                >
                                  <FaRegTrashCan className="del_lrCion" />
                                  <span>Delete</span>
                                </span>
                              )
                            ) : (
                              <></>
                            )}
                          </td>
                          <td>{serialNumber}</td>
                          {visibleColumns.map((column) => (
                            <td key={column}>
                              {
                                typeof row[column] === "object" &&
                                  row[column] !== null
                                  ? row[column]
                                  : row[column] // Render as string if not an object
                              }
                            </td>
                          ))}
                        </tr>
                      </>

                    );
                  })}
                </tbody>
              </table>
            </div>
          ))}
      </div>

      {
        !isTableHide && (
          <div className="_mainPaginate_ft">
            <div className="_rcl_bx">
              {/* <p>0 of 81 row(s) selected.</p> */}
              <p>{`Rows ${startRow} to ${endRow} of ${totalRecords} row(s) selected.`}</p>
              {/* <button className='_mngBtn'>Manage Column</button> */}
            </div>
            <div className="pagination_">
              <button
                className="_nxRev_btn"
                disabled={currentPage === 1}
                onClick={() => onPageChange(currentPage - 1)}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="8"
                  height="12"
                  viewBox="0 0 8 12"
                  fill="none"
                >
                  <path
                    d="M6.31348 1L1.40756 5.88384L6.34488 10.7359"
                    stroke="#000"
                    strokeWidth="1.63965"
                    strokeLinecap="round"
                  />
                </svg>
              </button>

              {renderPagination()}

              <button
                className="_nxRev_btn nxtPage_btn"
                disabled={currentPage === totalPages}
                onClick={() => onPageChange(currentPage + 1)}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="8"
                  height="12"
                  viewBox="0 0 8 12"
                  fill="none"
                >
                  <path
                    d="M6.31348 1L1.40756 5.88384L6.34488 10.7359"
                    stroke="#000"
                    strokeWidth="1.63965"
                    strokeLinecap="round"
                  />
                </svg>
              </button>
            </div>
          </div>
        )
      }
      <div
        className={`offcanvas offcanvas-end common_offCanvas ${filtersDropdownOpen ? "show" : ""
          }`}
        tabIndex={-1}
        style={{ visibility: filtersDropdownOpen ? "visible" : "hidden" }}
      >
        {filtersDropdownOpen && (
          <>
            <div className="offcanvas-header">
              <div className="d-flex gap-2 align-items-center">
                <h5 className="offcanvas-title"> Filters </h5>
                <div className="_counts"> {count} </div>
              </div>
              <CrossButton type="button" className="_switchBtn  __animEffect_btn" style={{ marginLeft: 'auto' }} onClick={() => setFiltersDropdownOpen(!filtersDropdownOpen)}>
                <svg className="cross" xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
                  <path
                    d="M12.5321 0.477671C12.4422 0.387555 12.3353 0.316061 12.2177 0.267281C12.1001 0.2185 11.9741 0.193391 11.8468 0.193391C11.7195 0.193391 11.5934 0.2185 11.4758 0.267281C11.3582 0.316061 11.2514 0.387555 11.1615 0.477671L6.40798 5.22143L1.6545 0.46795C1.56451 0.377952 1.45766 0.306563 1.34008 0.257857C1.22249 0.20915 1.09646 0.184082 0.969185 0.184082C0.84191 0.184082 0.715881 0.20915 0.598294 0.257857C0.480707 0.306563 0.373865 0.377952 0.283868 0.46795C0.19387 0.557947 0.122481 0.664789 0.0737746 0.782376C0.0250685 0.899963 -9.48274e-10 1.02599 0 1.15327C9.48275e-10 1.28054 0.0250684 1.40657 0.0737746 1.52416C0.122481 1.64175 0.19387 1.74859 0.283868 1.83858L5.03735 6.59206L0.283868 11.3455C0.19387 11.4355 0.122481 11.5424 0.0737746 11.66C0.0250685 11.7776 0 11.9036 0 12.0309C0 12.1581 0.0250685 12.2842 0.0737746 12.4017C0.122481 12.5193 0.19387 12.6262 0.283868 12.7162C0.373865 12.8062 0.480707 12.8776 0.598294 12.9263C0.715881 12.975 0.84191 13 0.969185 13C1.09646 13 1.22249 12.975 1.34008 12.9263C1.45766 12.8776 1.56451 12.8062 1.6545 12.7162L6.40798 7.9627L11.1615 12.7162C11.2515 12.8062 11.3583 12.8776 11.4759 12.9263C11.5935 12.975 11.7195 13 11.8468 13C11.974 13 12.1001 12.975 12.2177 12.9263C12.3353 12.8776 12.4421 12.8062 12.5321 12.7162C12.6221 12.6262 12.6935 12.5193 12.7422 12.4017C12.7909 12.2842 12.816 12.1581 12.816 12.0309C12.816 11.9036 12.7909 11.7776 12.7422 11.66C12.6935 11.5424 12.6221 11.4355 12.5321 11.3455L7.77861 6.59206L12.5321 1.83858C12.9015 1.46919 12.9015 0.847062 12.5321 0.477671Z"
                    fill="black" />
                </svg>
              </CrossButton>
            </div>

            <div className="offcanvas-body">
              <div className="_tableFilter_inrFx">
                <div className="_leftFilts">
                  {![1, 3, 4].includes(activeStatus) && (
                    <div className="_filtrFlx mt-2">
                      <CommonDateRange
                        initialStartDate={
                          initialListFilters?.start_date
                            ? initialListFilters?.start_date
                            : ""
                        }
                        initialEndDate={
                          initialListFilters?.end_date
                            ? initialListFilters?.end_date
                            : ""
                        }
                        onApply={(data) =>
                          // dropdownFilterOnChange(data)
                          setfilterlabel((s) => ({
                            ...s,
                            start_date: moment(data?.startDate),
                            end_date: moment(data?.endDate),
                          }))
                        }
                        datePrefield={
                          !initialListFilters?.start_date &&
                            !initialListFilters?.end_date
                            ? false
                            : true
                        }
                      />
                      {/* <input type='date' className='simpleDate_picker' /> */}
                    </div>
                  )}
                  {hidePartyFilter ? <div className="_filtrFlx">
                    <CustomSelect
                      options={dropdownConsignorList?.map((el) => {
                        return {
                          label: el?.name,
                          value: el?._id,
                        };
                      })}
                      name="consignor_id"
                      label="Select Party"
                      placeholder="Select Party"
                      value={
                        filterlabel?.consignor_id
                          ? filterlabel?.consignor_id
                          : initialListFilters?.consignor_id
                      }
                      onSelect={(data) => {
                        // dropdownFilterOnChange(data, "consignor_id");
                        setfilterlabel((s) => ({ ...s, consignor_id: data }));
                      }}
                    />
                  </div> : <></>}
                  <div className="_filtrFlx">
                    <CustomSelect
                      options={dropdownBranchList?.map((el) => {
                        return {
                          label: el?.branch,
                          value: el?._id,
                        };
                      })}
                      name="branch_id"
                      label="Select Branch"
                      placeholder="Select Branch"
                      value={
                        filterlabel?.branch_id
                          ? filterlabel?.branch_id
                          : initialListFilters?.branch_id
                      }
                      onSelect={(data) => {
                        // dropdownFilterOnChange(data, "branch_id");
                        setfilterlabel((s) => ({ ...s, branch_id: data }));
                      }}
                    />
                  </div>
                  <div className="_filtrFlx">
                    <CityDropdownForTrip
                      label="From Station"
                      placeholder="From Station"
                      fetchData={fetchFromCity}
                      pageSize={20}
                      selectedItem={filterlabel?.from_location ? filterlabel?.from_location : initialListFilters?.from_location}
                      onChange={(data) => setfilterlabel((s) => ({ ...s, from_location: data }))}
                    />
                    {/* <CustomSelect
                      options={[
                        { label: "All", value: "", cityStateLabel: 'All' },
                        ...cities?.map((el) => {
                          return {
                            ...el,
                            label: el?.name,
                            value: el?.name,
                          };
                        }),
                      ]}
                      optionShowCityState={true}
                      label="From Station"
                      placeholder="From Station"
                      value={
                        filterlabel?.from_location
                          ? filterlabel?.from_location
                          : initialListFilters?.from_location
                      }
                      onSelect={(data) => {
                        // dropdownFilterOnChange(data, "from_location");
                        setfilterlabel((s) => ({ ...s, from_location: data }));
                      }}
                    /> */}
                  </div>
                  <div className="_filtrFlx">
                    <CityDropdownForTrip
                      label="To Station"
                      placeholder="To Station"
                      fetchData={fetchFromCity}
                      pageSize={20}
                      selectedItem={filterlabel?.to_location ? filterlabel?.to_location : initialListFilters?.to_location}
                      onChange={(data) => setfilterlabel((s) => ({ ...s, to_location: data }))}
                    />
                    {/* <CustomSelect
                      label="To Station"
                      options={[
                        { label: "All", value: "", cityStateLabel: 'All' },
                        ...cities?.map((el) => {
                          return {
                            ...el,
                            label: el?.name,
                            value: el?.name,
                          };
                        }),
                      ]}
                      optionShowCityState={true}
                      placeholder="To Station"
                      value={
                        filterlabel?.to_location
                          ? filterlabel?.to_location
                          : initialListFilters?.to_location
                      }
                      onSelect={(data) => {
                        // dropdownFilterOnChange(data, "to_location");
                        setfilterlabel((s) => ({ ...s, to_location: data }));
                      }}
                    /> */}
                  </div>
                  <div className="_filtrFlx">
                    <CustomSelect
                      label="POD Status"
                      options={[
                        { label: "All", value: "" },
                        ...masterData?.pod_status_list?.map((el) => {
                          return {
                            label: el?.name,
                            value: el?.id,
                          };
                        }),
                      ]}
                      placeholder="POD Status"
                      value={
                        filterlabel?.pod_status
                          ? filterlabel?.pod_status
                          : initialListFilters?.pod_status
                      }
                      onSelect={(data) => {
                        // dropdownFilterOnChange(data, "pod_status");
                        setfilterlabel((s) => ({ ...s, pod_status: data }));
                      }}
                    />
                  </div>
                  <div className="_filtrFlx">
                    <CustomSelect
                      label="EWay Bill Status"
                      options={[{ label: "All", value: '' }, ...masterData?.eway_bill_status_list?.map((el) => {
                        return {
                          label: el?.name,
                          value: el?.id,
                        };
                      })]}
                      placeholder="EWay Bill Status"
                      value={
                        filterlabel?.eway_bill_status
                          ? filterlabel?.eway_bill_status
                          : initialListFilters?.eway_bill_status
                      }
                      onSelect={(data) => {
                        // dropdownFilterOnChange(data, "eway_bill_status");
                        setfilterlabel((s) => ({ ...s, eway_bill_status: data }));
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="offcanvas-footer">
              <AddButton
                name="Save"
                className="_addComm_btn"
                onClick={(e) => saveButtonApicall(e)}
                buttonTitle="Save"
              />

              {count > 0 && (
                <button
                  className="_cancel_btn"
                  onClick={(e) => {
                    setfilterlabel((s) => ({
                      ...s,
                      branch_id: { label: "", value: "" },
                      consignor_id: { label: "", value: "" },
                      start_date: "",
                      end_date: "",
                      from_location: { label: "", value: "" },
                      to_location: { label: "", value: "" },
                      pod_status: { label: "", value: "" },
                      eway_bill_status: { label: "", value: "" },
                    }));
                    // setFiltersDropdownOpen(false);
                    AllClearResetFunction();
                  }}
                >
                  Reset
                </button>
              )}
            </div>
          </>
        )}
      </div>
      <div className={filtersDropdownOpen ? "offBack_drop" : ""}></div>

      {
        viewsDropdownOpen && (
          <CommonModal {...handleDragProps}>
            {isTemplateName ? (
              <div className="pr_procssBx_grid p-3">
                <div className="_divDivide_half">
                  <CommonInput
                    type="text"
                    label="Template Name "
                    placeholder="Template Name "
                    name="name"
                    value={
                      invoiceBillRaiseData?.template_id?.label
                        ? invoiceBillRaiseData?.template_id?.label
                        : ""
                    }
                    disabled
                  />
                </div>
              </div>
            ) : (
              <></>
            )}
            <div className="_customCol_body">
              <div
                className={
                  allColumns?.filter((el) => (el?.view != 1 ? el : ""))?.length >
                    0
                    ? `_cstColDiv1 _cstColDiv_halfRg ${allColumns?.filter((el) => (el?.view != 0 ? el : ""))
                      ?.length == 0
                      ? "_cstFull_divHide"
                      : ""
                    }`
                    : "_cstColDiv1"
                }
              >
                <p className="_clstHead">
                  Selected Columns (
                  {allColumns?.filter((el) => (el?.view != 0 ? el : ""))?.length})
                </p>
                <div className="_colsListing_bx">
                  <DragDropContext onDragEnd={(result) => onDragEnd(result)}>
                    <Droppable droppableId="lrSelectedlist">
                      {(provided) => (
                        <div ref={provided.innerRef} {...provided.droppableProps}>
                          {allColumns.map((item, index) => {
                            return (
                              item.view == 1 && (
                                <Draggable
                                  draggableId={getColumnId(item)}
                                  index={index}
                                  key={getColumnId(item)}
                                >
                                  {(provided) => (
                                    <div
                                      ref={provided.innerRef}
                                      {...provided.draggableProps}
                                    >
                                      <div
                                        className="column-toggle-dropdown-item text-nowrap extra-padding"
                                        draggable={true}
                                        {...provided.dragHandleProps}
                                      >
                                        <svg
                                          fill="#656565"
                                          version="1.1"
                                          id="icon"
                                          xmlns="http://www.w3.org/2000/svg"
                                          xmlnsXlink="http://www.w3.org/1999/xlink"
                                          width="20px"
                                          height="20px"
                                          viewBox="0 0 32 32"
                                          xmlSpace="preserve"
                                        >
                                          <style
                                            type="text/css"
                                            dangerouslySetInnerHTML={{
                                              __html: "\n\t.st0{fill:none;}\n",
                                            }}
                                          />
                                          <title>draggable</title>
                                          <rect
                                            x={10}
                                            y={6}
                                            width={4}
                                            height={4}
                                          />
                                          <rect
                                            x={18}
                                            y={6}
                                            width={4}
                                            height={4}
                                          />
                                          <rect
                                            x={10}
                                            y={14}
                                            width={4}
                                            height={4}
                                          />
                                          <rect
                                            x={18}
                                            y={14}
                                            width={4}
                                            height={4}
                                          />
                                          <rect
                                            x={10}
                                            y={22}
                                            width={4}
                                            height={4}
                                          />
                                          <rect
                                            x={18}
                                            y={22}
                                            width={4}
                                            height={4}
                                          />
                                          <rect
                                            id="_Transparent_Rectangle_"
                                            className="st0"
                                            width={32}
                                            height={32}
                                          />
                                        </svg>
                                        <input
                                          type="checkbox"
                                          checked={true}
                                          className="_avPointer"
                                          onChange={() =>
                                            handleCheckboxChange(item)
                                          }
                                        />
                                        {item.Header}
                                      </div>
                                    </div>
                                  )}
                                </Draggable>
                              )
                            );
                          })}
                        </div>
                      )}
                    </Droppable>
                  </DragDropContext>
                </div>
              </div>
              <div
                className={
                  allColumns?.filter((el) => (el?.view == 0 ? el : ""))?.length >
                    0
                    ? `_cstColDiv2 _cstColDiv2_visible ${allColumns?.filter((el) => (el?.view != 0 ? el : ""))
                      ?.length == 0
                      ? "_cstFull_divShow"
                      : ""
                    }`
                    : "_cstColDiv2"
                }
              >
                <p className="_clstHead">
                  Unselected Columns (
                  {allColumns?.filter((el) => (el?.view == 0 ? el : ""))?.length})
                </p>
                <div className="_colsListing_bx">
                  <DragDropContext onDragEnd={(result) => onDragEnd(result)}>
                    <Droppable droppableId="lrUnselectedlist">
                      {(provided) => (
                        <div ref={provided.innerRef} {...provided.droppableProps}>
                          {allColumns.map((item, index) => {
                            return (
                              item.view == 0 && (
                                <Draggable
                                  draggableId={getColumnId(item)}
                                  index={index}
                                  key={getColumnId(item)}
                                >
                                  {(provided) => (
                                    <div
                                      ref={provided.innerRef}
                                      {...provided.draggableProps}
                                    >
                                      <div
                                        className="column-toggle-dropdown-item text-nowrap extra-padding"
                                        draggable={true}
                                        {...provided.dragHandleProps}
                                      >
                                        <svg
                                          fill="#656565"
                                          version="1.1"
                                          id="icon"
                                          xmlns="http://www.w3.org/2000/svg"
                                          xmlnsXlink="http://www.w3.org/1999/xlink"
                                          width="20px"
                                          height="20px"
                                          viewBox="0 0 32 32"
                                          xmlSpace="preserve"
                                        >
                                          <style
                                            type="text/css"
                                            dangerouslySetInnerHTML={{
                                              __html: "\n\t.st0{fill:none;}\n",
                                            }}
                                          />
                                          <title>draggable</title>
                                          <rect
                                            x={10}
                                            y={6}
                                            width={4}
                                            height={4}
                                          />
                                          <rect
                                            x={18}
                                            y={6}
                                            width={4}
                                            height={4}
                                          />
                                          <rect
                                            x={10}
                                            y={14}
                                            width={4}
                                            height={4}
                                          />
                                          <rect
                                            x={18}
                                            y={14}
                                            width={4}
                                            height={4}
                                          />
                                          <rect
                                            x={10}
                                            y={22}
                                            width={4}
                                            height={4}
                                          />
                                          <rect
                                            x={18}
                                            y={22}
                                            width={4}
                                            height={4}
                                          />
                                          <rect
                                            id="_Transparent_Rectangle_"
                                            className="st0"
                                            width={32}
                                            height={32}
                                          />
                                        </svg>
                                        <input
                                          type="checkbox"
                                          checked={false}
                                          className="_avPointer"
                                          onChange={() =>
                                            handleCheckboxChange(item)
                                          }
                                        />
                                        {item.Header}
                                      </div>
                                    </div>
                                  )}
                                </Draggable>
                              )
                            );
                          })}
                        </div>
                      )}
                    </Droppable>
                  </DragDropContext>
                </div>
              </div>
            </div>
          </CommonModal>
        )
      }
    </>
  );
};

export default React.memo(CustomTable);
